import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { PsicologoService } from 'src/app/shared/services/psicologo.service';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';

@Component({
  templateUrl: './termos-uso-dados-pessoais.component.html',
  styleUrls: ['./termos-uso-dados-pessoais.component.scss'],
  imports:[convivaCommonImports],
  standalone: true
})
export class PageTermosUsoDeDadosPessoaisComponent {
  userLogado: UserLoginSed | null = null;

  toastr = inject(ToastrService);
  authService = inject(AuthService);
  psicologoService = inject(PsicologoService);
  spinner = inject(NgxSpinnerService);
  router = inject(Router);

  constructor() {
    this.userLogado = this.authService.getUser();
  }

  autorizacaoUsoDados:boolean = false;

  async OnSubmit(autorizacao:number){
    this.spinner.show();
    const body = {
      status: autorizacao,
      cpf:this.userLogado?.cpf,
      codigoUsuario:0
    };

    const response =  await lastValueFrom(this.psicologoService.setAutorizacaoUsoDados(body))
      .catch(err => err);
    if(!response.isSucess){
      this.spinner.hide();
      this.toastr.error('Erro ao autorizar uso de dados!');
      return;
    }
    this.userLogado!.autorizacaoUsoDados = autorizacao;
    this.authService.setUser(this.userLogado!);

    this.spinner.hide();

    if(autorizacao === 1){
      this.toastr.success('Usuário autorizado!');
      this.router.navigate(['/home']);
    }else{
      this.toastr.warning('Usuário não autorizado!');
      this.router.navigate(['/home']);
    }

  }


}
